<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex xs12 pa-2 text-xs-right>
          <v-btn flat icon @click="handleCloseDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 pa-2 class="form-control" :class="{ 'has-error': errors.has('name') }">
          <div class="caption">ชื่อการแจ้งเตือน <span class="red--text">*</span></div>
          <input
            type="text"
            placeholder="ชื่อการแจ้งเตือน"
            v-model="name"
            v-validate="'required'"
            name="name"
          />
          <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
        </v-flex>

        <v-flex xs6 pa-2 class="form-control" :class="{ 'has-error': errors.has('duration') }">
          <div class="caption">ระยะเวลา <span class="red--text">*</span></div>
          <div>
            <multiselect
              v-model="duration"
              :options="durationOptions"
              :allow-empty="true"
              :searchable="false"
              :openDirection="'bottom'"
              selectLabel
              v-validate="'required'"
              name="duration"
            ></multiselect>
            <span class="text-error" v-if="errors.has('duration')">{{
              errors.first('duration')
            }}</span>
          </div>
        </v-flex>

        <v-flex xs6 pa-2 class="form-control" :class="{ 'has-error': errors.has('affiliation') }">
          <div class="caption">สังกัด <span class="red--text">*</span></div>
          <div>
            <multiselect
              v-model="affiliation"
              :options="affiliationOptions"
              :allow-empty="true"
              :searchable="false"
              :openDirection="'bottom'"
              selectLabel
              v-validate="'required'"
              name="affiliation"
            ></multiselect>
            <span class="text-error" v-if="errors.has('affiliation')">{{
              errors.first('affiliation')
            }}</span>
          </div>
        </v-flex>

        <v-flex xs6 pa-2 class="form-control" :class="{ 'has-error': errors.has('department') }">
          <div class="caption">แผนก <span class="red--text">*</span></div>
          <div>
            <multiselect
              v-model="department"
              :options="departmentOptions"
              :allow-empty="true"
              :searchable="false"
              :openDirection="'bottom'"
              selectLabel
              v-validate="'required'"
              name="department"
            ></multiselect>
            <span class="text-error" v-if="errors.has('department')">{{
              errors.first('department')
            }}</span>
          </div>
        </v-flex>

        <v-flex xs12 pa-2 class="form-control" :class="{ 'has-error': messageInvalid }">
          Message
          <IntentGroup
            v-model="messages"
            :hasAlternative="false"
            :maxIntent="1"
            :availableBubbles="['text', 'button', 'image', 'generic', 'line_flex', 'line_imagemap']"
          />
          <span class="text-error" v-if="messageInvalid">Missing message</span>
        </v-flex>

        <v-flex xs12 pa-2>
          <v-flex text-xs-center pt-4>
            <v-btn @click="handleCloseDialog" outline color="grey">Cancel</v-btn>
            <v-btn @click="handleSubmit" color="primary" :loading="loading">Save</v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import hopinnHrApi from '@/api/hopinn-hr'
import IntentGroup from '@/components/view/intent/IntentGroup'
import { mapGetters } from 'vuex'
export default {
  props: ['itemEdit'],
  inject: ['$validator'],
  components: {
    Multiselect,
    IntentGroup
  },
  mounted() {
    this.handleGetDivisionOptions()
    this.handleGetDepartmentOptions()
  },
  created() {
    if (this.itemEdit) {
      this.name = this.itemEdit.name
      this.affiliation = this.itemEdit.affiliation
      this.duration = this.itemEdit.day_length
      this.department = this.itemEdit.department
      const oldMessage = JSON.parse(this.itemEdit.a_val)
      this.messages = oldMessage
    }
  },
  data() {
    return {
      name: '',
      duration: '',
      affiliation: '',
      department: '',
      durationOptions: ['30', '60', '90'],
      departmentOptions: [],
      affiliationOptions: [],
      messages: [[]],
      messageInvalid: false,
      loading: false
    }
  },
  methods: {
    handleCloseDialog() {
      this.$emit('close')
      this.clearField()
    },
    clearField() {
      this.name = ''
      this.duration = ''
      this.affiliation = ''
      this.department = ''
      this.messages = [[]]
      this.messageInvalid = false
      this.$validator.reset()
    },

    async handleSubmit() {
      const vm = this
      try {
        const tempMessage = vm.checkEmptyMessage(vm.messages)
        vm.messageInvalid = tempMessage && tempMessage[0].length === 0
        let formValid = await vm.$validator.validateAll()
        if (formValid && !vm.messageInvalid) {
          vm.$store.dispatch('loading')
          vm.loading = true
          const data = {
            pageid: vm.pageid,
            name: vm.name,
            day_length: vm.duration,
            affiliation: vm.affiliation,
            department: vm.department,
            a_val: JSON.stringify(tempMessage),
            active: true
          }

          let response
          if (vm.itemEdit) {
            const dataUpdate = {
              id: vm.itemEdit.id,
              ...data
            }
            response = await hopinnHrApi.updateSop({
              data: dataUpdate
            })
          } else {
            response = await hopinnHrApi.postCreateSop({
              data
            })
          }
          vm.$store.dispatch('loading')
          vm.loading = false
          if (response.data.responsecode === 200) {
            vm.$emit('close', 'refetchSop')
            vm.clearField()
          }
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    async handleGetDivisionOptions() {
      const vm = this
      const affiliationResponse = await hopinnHrApi.getAffiliation()
      const tempDivision = []
      affiliationResponse.data.data.forEach((item) => {
        tempDivision.push(item.engname)
      })
      tempDivision.unshift('All')
      if (tempDivision) vm.affiliationOptions = tempDivision
    },
    async handleGetDepartmentOptions() {
      const vm = this
      const departmentResponse = await hopinnHrApi.getDepartment()
      const tempDepartmentOptions = []
      departmentResponse.data.data.forEach((item) => {
        tempDepartmentOptions.push(item.engname)
      })
      tempDepartmentOptions.unshift('All')
      if (tempDepartmentOptions) vm.departmentOptions = tempDepartmentOptions
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageid() {
      return this.selectedBot.pageid
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/DialogSop.vue